import { ILink, INode } from "components/Shared/Sankey/interface"
import { IMapLinkToNode, TypeProperty } from "./interface"
import { SOURCE, TARGET } from "./constants"
import { NodeColorManager } from "./nodeColorManager"

const mapLinkToNode = (property: TypeProperty) => (
	link: ILink
): IMapLinkToNode => ({
	id: link[property],
	nodeColor: "",
	type: property,
})

const mapNodeRight = () => mapLinkToNode(SOURCE)

const mapNodeLeft = () => mapLinkToNode(TARGET)

const filterNodeDuplicated = (node: INode, index: number, self: INode[]) =>
	self.findIndex((n) => n.id === node.id) === index

const assignedColor = (
	nodeColorManager: NodeColorManager,
	node: IMapLinkToNode
) => {
	if (node.type) {
		node.nodeColor = nodeColorManager.getNextColor(node.type)
	}
	delete node.type
	return node
}

export const createNodes = (
	links: ILink[],
	colorsLeft: string[],
	colorsRight: string[]
): INode[] => {
	const nodeColorManager = new NodeColorManager(colorsLeft, colorsRight)

	return [...links.map(mapNodeLeft()), ...links.map(mapNodeRight())]
		.filter(filterNodeDuplicated)
		.map((node) => assignedColor(nodeColorManager, node))
}
